import { AxiosResponse } from 'axios'
import api from 'src/services/api'
import {
  IParceiro,
  ListagemParceirosQuery,
  ListagemResponse,
  ObjetoDescricaoGenerico
} from '../../types'

export const salvarParceiro: (
  parceiro: IParceiro
) => Promise<AxiosResponse<void>> = parceiro => {
  const funcionarios = parceiro.funcionarios.map(f => {
    const especialidadesId = f.especialidades.map(e => e.id)

    return { ...f, especialidades: especialidadesId }
  })

  const body = {
    ...parceiro,
    funcionarios,
    localAtendimentoId: parceiro.localAtendimento?.id,
    taxaOPME: parceiro.taxaOPME ? parseFloat(parceiro.taxaOPME) : null
  }

  return api.post('/parceiro', body)
}

export const listarParceiros: (
  query: ListagemParceirosQuery
) => Promise<AxiosResponse<ListagemResponse<IParceiro>>> = query => {
  return api.get(`/parceiro/listagem?${new URLSearchParams(query)}`)
}

export const obterItemListagemPorId: (
  parceiroId: string
) => Promise<AxiosResponse<IParceiro>> = parceiroId => {
  return api.get(`/parceiro/listagem/${parceiroId}`)
}

export const buscarParceiroPorId: (
  parceiroId: string
) => Promise<AxiosResponse<IParceiro>> = parceiroId => {
  return api.get(`/parceiro/${parceiroId}`)
}

export const obterTaxaOpmePorLocalAtendimentoId: (
  localAtendimentoId: string
) => Promise<AxiosResponse<number>> = localAtendimentoId => {
  return api.post(`/parceiro/${localAtendimentoId}/taxaopme`)
}

export const obterFornecedoresPorLocalAtendimentoId: (
  localAtendimentoId: string
) => Promise<AxiosResponse<ObjetoDescricaoGenerico[]>> = localAtendimentoId => {
  return api.post(`/parceiro/${localAtendimentoId}/fornecedoresOpme`)
}

export const obterHorariosBaixoFluxoPorLocalAtendimentoId: (
  localAtendimentoId: string
) => Promise<AxiosResponse<string | null>> = localAtendimentoId => {
  return api.get(`/parceiro/${localAtendimentoId}/horariosBaixoFluxo`)
}

export const excluirParceiro: (
  parceiroId: string
) => Promise<AxiosResponse<void>> = parceiroId => {
  return api.delete(`/parceiro/${parceiroId}`)
}
